import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { loadStripe, Stripe, StripeCardElement, StripeElements } from '@stripe/stripe-js';
import { ChatServiceService } from 'src/app/Services/chat-service.service';

@Component({
  selector: 'app-testing',
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.css']
})
export class TestingComponent implements OnInit, OnDestroy {
  stripe!: Stripe | null;
  elements!: StripeElements;
  card!: StripeCardElement;
  clientSecret!: string;

  constructor(private http: HttpClient) {}

  async ngOnInit() {
 
    this.stripe = await loadStripe('pk_live_51SCvIwLymiDxDisE9bbUqleSPdelPmQyRkJKQSPQJhDtm4HsmzNUhpd2cl5cJEWmxxPr9e4k0AlkwyBxhvhyftmo00f6BGfwrB');

    if (this.stripe) {
      this.elements = this.stripe.elements();
      this.card = this.elements.create('card');
      this.card.mount('#card-element'); 
    }
  }

  async createPayment() {
    
    this.http.post<any>('https://safroo-dev-api.azurewebsites.net/api/payment/create-payment-intent', {
      amount: 1,   
      currency: 'usd',
      bookingId: 273,
      userId: 241
    }).subscribe(async (res) => {
      this.clientSecret = res.clientSecret;

    
      if (this.stripe && this.clientSecret) {
        const { error, paymentIntent } = await this.stripe.confirmCardPayment(this.clientSecret, {
          payment_method: {
            card: this.card
          }
        });

        if (error) {
          alert('Payment failed: ' + error.message);
        } else if (paymentIntent && paymentIntent.status === 'succeeded') {
          alert('Payment successful!');
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.card) {
      this.card.destroy();
    }
  }
}